import styled from "styled-components";

export const RedAsterisk = styled.i`
  color: red;
`;
